import BackupForm from '../../components/BackupForm';
import {
  Container,
} from './styles';

export default function NewBackupPage() {
  return (
    <Container>
      <h1>Novo Backup</h1>
      <BackupForm />
    </Container>
  );
}
